var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncorrectDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512",
      opacity: 0.5,
      pointerEvents: "none"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12 10.586 5.656-5.656a.997.997 0 0 1 1.415.001l.02.02A9.977 9.977 0 0 1 22 12c0 5.519-4.481 10-10 10S2 17.519 2 12 6.481 2 12 2c1.169 0 2.291.201 3.334.57a1.001 1.001 0 0 1-.668 1.886A8.004 8.004 0 0 0 4 12c0 4.415 3.585 8 8 8a8.004 8.004 0 0 0 7.544-10.666 7.981 7.981 0 0 0-1.225-2.238L13.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414L12 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L10.586 12 8.293 9.707a1 1 0 0 1 1.414-1.414z",
    fill: "#ff0000",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrectDisabled);
export default __webpack_public_path__ + "static/media/incorrectDisabled.2aa917cd562eb2729fd7d6ec7c224815.svg";
export { ForwardRef as ReactComponent };